import React from 'react';
import { Empty, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

/**
 * Empty state orientativo para listas/tabelas vazias.
 * Uso: locale={{ emptyText: <EmptyStateGuide ... /> }} ou render direto.
 */
function EmptyStateGuide({
  title,
  description,
  actionLabel,
  onAction,
  icon,
  image = Empty.PRESENTED_IMAGE_SIMPLE,
}) {
  const descriptionNode = (
    <span>
      {title}
      {description ? (
        <>
          <br />
          {description}
        </>
      ) : null}
    </span>
  );

  return (
    <Empty image={image} description={descriptionNode}>
      {actionLabel && onAction ? (
        <Button type="primary" icon={icon === undefined ? <PlusOutlined /> : icon || undefined} onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Empty>
  );
}

export default EmptyStateGuide;
